// extracted by css-extract-rspack-plugin
export default {"root":"root-kyuN41 text-body-label"};